





















import Vue from "vue";
import { Component } from "vue-property-decorator";
import { DashboardService } from "@/services/dashboard.service";

@Component({
})
export default class EventosCardSuporte extends Vue {
  totalEventos: number | null = null;
  loadingEventos = false;

  centro = {
    title: "Eventos",
    value: 0,
  };

  mounted() {
    this.CarregarQuantidadeEventos();
  }

  async CarregarQuantidadeEventos() {
    this.loadingEventos = true;
    this.totalEventos = await DashboardService.QuantidadeEventos().finally(
      () => (this.loadingEventos = false)
    );
  }
}
